// extracted by mini-css-extract-plugin
module.exports = {"singleProject":"SingleProject_singleProject__16eGj","image":"SingleProject_image__248IV","links":"SingleProject_links__1Oe4p"};